import { Dispatch } from "redux";
import api from "../../api/api";
import {
    resetLetestTeacher, setLetestTeacherlist,setStudentBySchool, seterror, setloading
} from "../reducers/getLetestTeacherReducer";

const  LetestTeacher = ( token: any,type:any,id: any, sort: string = "Newest First", search?: string, grade?: string, subject?: string) => async (dispatch: Dispatch) => {
   dispatch(setloading(true));
    const baseUrl = type === 'Teacher'
    ? `school-admin/school/recent-techer-list/${id}/`
    : `school-admin/school/recent-student-list/${id}/`;

  const params = new URLSearchParams();
  if (sort)    params.append("sort", sort);
  if (search)  params.append("search", search);
  if (grade)   params.append("grade", grade);
  if (subject) params.append("subject", subject);

  const queryString = params.toString();
  const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;

   try {
      const result = await api.get(url,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`

          },
        }
       )
       if(result){
        dispatch(setloading(false));
       if (result?.status === 200) {
        if (type === 'Teacher') {
            dispatch(setLetestTeacherlist(result?.data?.data || []));
        } else {
            dispatch(setStudentBySchool(result?.data?.data || []));
        }
      }
      else {
        dispatch(setloading(false));
        dispatch(seterror(result.data?.message ?? "Something Went Wrong!"));
      }
   }
   }
   catch (error: any) {
    dispatch(seterror(error.response.data.message));
   }
}


export { LetestTeacher, resetLetestTeacher };

